document.addEventListener('DOMContentLoaded', function() {

    const inputsAbrirModal = document.querySelectorAll('input.inputAbrirModal');
    const modal = document.querySelector('#modalAgregarReferencias');

    if (!modal || inputsAbrirModal.length === 0) return;

    const contReferencias = modal.querySelector('.contReferencias');
    const inputFiltro     = modal.querySelector('.input-filtro-buscar');

    let referenciasCargadas = false;
    let tipoRefActual = '';

    inputsAbrirModal.forEach(input => {
        input.addEventListener('focus', function() {
            const inputOrigen = modal.querySelector('input[name="origenModal"]');
            if (inputOrigen) inputOrigen.value = this.getAttribute('data-origen') || '';
            this.value = '';

            const idModalOrigen = this.getAttribute('data-origen');
            if (idModalOrigen) {
                const modalOrigen = document.querySelector('#' + idModalOrigen);
                if (modalOrigen) {
                    const inputIdReferencia   = modalOrigen.querySelector('#idReferencia');
                    const inputCodReferencia  = modalOrigen.querySelector('#codReferencia');
                    const inputDescReferencia = modalOrigen.querySelector('#descReferencia');

                    if (!inputIdReferencia || !inputCodReferencia || !inputDescReferencia) return;

                    inputIdReferencia.value   = '';
                    inputCodReferencia.value  = '';
                    inputDescReferencia.value = '';

                    inputIdReferencia.classList.remove('inputRojo');
                    inputCodReferencia.classList.remove('inputRojo');
                    inputDescReferencia.classList.remove('inputRojo');
                }
            }
        });
    });

    // Carga las referencias al abrir el modal; recarga si cambia el tipo
    document.addEventListener('focusin', function(e) {
        if (!e.target.classList.contains('inputAbrirModal')) return;
        if (e.target.getAttribute('data-modal') !== 'modalAgregarReferencias') return;

        const tipoRef = e.target.getAttribute('data-tipo-ref') || '';

        if (referenciasCargadas && tipoRef === tipoRefActual) return;

        tipoRefActual = tipoRef;
        referenciasCargadas = false;
        cargarReferencias(tipoRef);
    });

    // Filtro de búsqueda
    if (inputFiltro) {
        inputFiltro.addEventListener('input', function() {
            const termino = this.value.trim().toLowerCase();
            const items = contReferencias.querySelectorAll('.referencia');
            items.forEach(item => {
                const codigo = (item.getAttribute('data-codigo') || '').toLowerCase();
                const ref    = (item.getAttribute('data-ref') || '').toLowerCase();
                const tipo    = (item.getAttribute('data-tipo') || '').toLowerCase();
                item.style.display = (!termino || tipo.includes(termino) || codigo.includes(termino) || ref.includes(termino)) ? '' : 'none';
            });
        });
    }

    async function cargarReferencias(tipoRef = '') {
        contReferencias.innerHTML = '<p class="cargandoReferencias">Cargando referencias...</p>';

        try {
            const url = tipoRef
                ? `/api/configuracion/referencias/activas?tipo=${encodeURIComponent(tipoRef)}`
                : '/api/configuracion/referencias/listar';

            const respuesta = await fetch(url);
            const json      = await respuesta.json();

            if (respuesta.status !== 200 || !json.result) {
                contReferencias.innerHTML = '<p class="no-info">No se pudieron cargar las referencias.</p>';
                return;
            }

            const referencias = json.result;

            if (!referencias.length) {
                contReferencias.innerHTML = '<p class="no-info">No hay referencias disponibles.</p>';
                return;
            }
            
            contReferencias.innerHTML = referencias.map(ref => `
                <div class="referencia"
                     data-id="${ref.idReferencia}"
                     data-tipo="${escapeAttr(ref.tipoReferencia)}"
                     data-codigo="${escapeAttr(ref.codigoSap)}"
                     data-ref="${escapeAttr(ref.descripSap)}">
                    <article class="articuloCard">
                        <div class="articuloCardTitulo">
                            <h3>${escapeHtml(ref.tipoReferencia || '')}</h3>
                        </div>
                        <dl class="articuloCardLista">
                            <dt>Codigo:</dt>
                            <dd>${escapeHtml(ref.codigoSap || '')}</dd>
                            <dt>Referencia:</dt>
                            <dd>${escapeHtml(ref.descripSap || '')}</dd>
                        </dl>
                    </article>
                </div>
            `).join('');

            referenciasCargadas = true;

        } catch (error) {
            console.error('Error al cargar referencias:', error);
            contReferencias.innerHTML = '<p class="no-info">Error al cargar las referencias.</p>';
        }
    }

    // Delegación de clics sobre las referencias renderizadas dinámicamente
    contReferencias.addEventListener('click', function(e) {
        const item = e.target.closest('.referencia');
        if (!item) return;
        seleccionarReferencia(item);
    });

    function seleccionarReferencia(elemento) {
        const id        = elemento.getAttribute('data-id');
        const codigo    = elemento.getAttribute('data-codigo');
        const referencia = elemento.getAttribute('data-ref');

        const inputOrigenEl = modal.querySelector('input[name="origenModal"]');
        if (!inputOrigenEl) return;

        const idModalOrigen = inputOrigenEl.value;
        const modalOrigen   = document.querySelector('#' + idModalOrigen);

        if (!idModalOrigen || !modalOrigen || !id || !codigo || !referencia) {
            alert('Faltan datos para completar la acción');
            window.location.reload();
            return;
        }

        const inputIdReferencia   = modalOrigen.querySelector('#idReferencia');
        const inputCodReferencia  = modalOrigen.querySelector('#codReferencia');
        const inputDescReferencia = modalOrigen.querySelector('#descReferencia');

        if (!inputIdReferencia || !inputCodReferencia || !inputDescReferencia) {
            alert('No se encontraron los inputs destino');
            return;
        }

        inputIdReferencia.value   = id;
        inputCodReferencia.value  = codigo;
        inputDescReferencia.value = referencia;

        inputIdReferencia.setAttribute('readonly', true);
        inputCodReferencia.setAttribute('readonly', true);
        inputDescReferencia.setAttribute('readonly', true);

        const inputCiclo = modalOrigen.querySelector('#ciclo');
        if (inputCiclo) inputCiclo.focus();

        modal.classList.remove('modal--show');
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
        return String(str).replace(/"/g, '&quot;');
    }
});
